import { NodeModel } from "../_model/NodeModel";
import { DecorationCitrus } from "../citrus/decorationCitrus";
import { Types } from "../../utils/nodeTypes";
import Properties from "../_model/ModelEngineeringProperties";

class Citrus extends NodeModel {
    constructor() {
        super("Citrus");

        this.type = new Types().Citrus;

        this.x = 0;
        this.y = 0;
        this.xImg = () => this.x + 2;
        this.yImg = () => this.y + 2;
        this.height = 140;
        this.width = 140;
        this.operationSelected = '';
        this.srcImg = require("@/assets/Fluxogramas/citrus.png");
        this.data = [new Properties({...this })];
        this.CurrentTempAr = null
        this.jokerCaption = [];
        this.enableDoubledFCOJ = false;
        this.enableDoubledNFC = false;
        this.enableDoubledRFA = false;
        this.showPrecoceModal = false;
        this.showMediaModal = false;
        this.showTardiaModal = false;
        this.disableFCOJ = false;
        this.disableRFA = false;
        this.disableNFC = false;
        this.moduleOptionsFCOJ = '';
        this.moduleOptionsNFC = '';
        this.moduleOptionsRFA = '';
        this.propPrecoce = '';
        this.propMedia = '';
        this.propTardia = '';
        this.linesFCOJ = [];
        this.linesNFC = [];
        this.linesRFA = [];

        this.decorate = async function(callback) {
            this.decorator = new DecorationCitrus();
            await this.decorator.init(this, callback)
        };

        this.clone = () => {
            let cloned = new Citrus()

            cloned.id = this.id;
            cloned.idName = this.idName;
            cloned.type = this.type;
            cloned.x = this.x;
            cloned.y = this.y;
            cloned.height = this.height;
            cloned.width = this.width;
            cloned.decorator = null
            cloned.readOnly = this.readOnly
            cloned.expressionVisible = this.expressionVisible
            cloned.CurrentTempAr = this.CurrentTempAr
            cloned.data = this.data.map(d => d.clone());
            cloned.jokerCaption = this.jokerCaption
            cloned.enableDoubledFCOJ = this.enableDoubledFCOJ
            cloned.enableDoubledNFC = this.enableDoubledNFC
            cloned.enableDoubledRFA = this.enableDoubledRFA
            cloned.showPrecoceModal = this.showPrecoceModal
            cloned.showMediaModal = this.showMediaModal
            cloned.showTardiaModal = this.showTardiaModal
            cloned.disableFCOJ = this.disableFCOJ
            cloned.disableRFA = this.disableRFA
            cloned.disableNFC = this.disableNFC 
            cloned.moduleOptionsFCOJ = this.moduleOptionsFCOJ
            cloned.moduleOptionsNFC = this.moduleOptionsNFC
            cloned.moduleOptionsRFA = this.moduleOptionsRFA
            cloned.propPrecoce = this.propPrecoce
            cloned.propMedia = this.propMedia
            cloned.propTardia = this.propTardia
            cloned.linesFCOJ = this.linesFCOJ
            cloned.linesNFC = this.linesNFC
            cloned.linesRFA = this.linesRFA
            
            return cloned
        }

        this.copyFrom = (node) => {
            this.simpleCopyFrom(node);
            this.data = node.data.map(d => new Properties({...d }));
            this.CurrentTempAr = node.CurrentTempAr
            this.jokerCaption = node.jokerCaption
            this.enableDoubledFCOJ = node.enableDoubledFCOJ
            this.enableDoubledNFC = node.enableDoubledNFC
            this.enableDoubledRFA = node.enableDoubledRFA
            this.disableFCOJ = node.disableFCOJ
            this.disableRFA = node.disableRFA
            this.disableNFC = node.disableNFC
            this.moduleOptionsFCOJ = node.moduleOptionsFCOJ 
            this.moduleOptionsNFC = node.moduleOptionsNFC 
            this.moduleOptionsRFA = node.moduleOptionsRFA 
            this.propPrecoce = node.propPrecoce
            this.propMedia = node.propMedia
            this.propTardia = node.propTardia
            this.linesFCOJ = node.linesFCOJ
            this.linesRFA = node.linesRFA
            this.linesNFC = node.linesNFC
        }

        this.update = (node) => {
            if (node.attrs) {
                this.data = node.attrs;
            }

            if (node.CurrentTempAr) {
                this.CurrentTempAr = node.CurrentTempAr;
            }

            this.enableDoubledFCOJ = node.enableDoubledFCOJ;
            this.enableDoubledNFC = node.enableDoubledNFC;
            this.enableDoubledRFA = node.enableDoubledRFA;
            this.disableFCOJ = node.disableFCOJ; 
            this.disableRFA = node.disableRFA; 
            this.disableNFC = node.disableNFC; 
            this.moduleOptionsFCOJ = node.moduleOptionsFCOJ; 
            this.moduleOptionsNFC = node.moduleOptionsNFC; 
            this.moduleOptionsRFA = node.moduleOptionsRFA; 
            this.propPrecoce = node.propPrecoce;
            this.propMedia = node.propMedia;
            this.propTardia = node.propTardia;
            this.linesFCOJ = node.linesFCOJ;
            this.linesRFA = node.linesRFA;
            this.linesNFC = node.linesNFC;
            this.expressionVisible = node.expressionVisible;
            this.jokerCaption = node.jokerCaption;
        }
    }
}

export { Citrus };